export const DAY_TRADER = 'living-through-trading';
export const EMPLOYED_TRADER = 'another-job-primary-income';
export const ASPIRING_DAY_TRADER = 'learning-about-trading';
export const INVESTOR = 'long-term-investor';
export const PASSIVE_INVESTOR = 'funds-managed-by-third-party';
